var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 13V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H13",
    stroke: "#7A9526",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32812 14.4917L9.70813 11.4017C10.0481 10.9617 10.6781 10.8817 11.1181 11.2217L12.9482 12.6617C13.3882 13.0017 14.0181 12.9217 14.3581 12.4917L16.6682 9.51172",
    stroke: "#7A9526",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4812 15.8214L19.7612 16.3914C19.9012 16.6714 20.2512 16.9314 20.5612 16.9914L20.9412 17.0514C22.0812 17.2414 22.3512 18.0814 21.5312 18.9114L21.1812 19.2614C20.9512 19.5014 20.8212 19.9614 20.8912 20.2814L20.9412 20.4914C21.2512 21.8714 20.5212 22.4014 19.3212 21.6814L19.0612 21.5314C18.7512 21.3514 18.2512 21.3514 17.9412 21.5314L17.6812 21.6814C16.4712 22.4114 15.7412 21.8714 16.0612 20.4914L16.1112 20.2814C16.1812 19.9614 16.0512 19.5014 15.8212 19.2614L15.4712 18.9114C14.6512 18.0814 14.9212 17.2414 16.0612 17.0514L16.4412 16.9914C16.7412 16.9414 17.1012 16.6714 17.2412 16.3914L17.5212 15.8214C18.0612 14.7314 18.9412 14.7314 19.4812 15.8214Z",
    stroke: "#7A9526",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteChart);
export default __webpack_public_path__ + "static/media/favorite-chart.8e2fcfdc7c5b9fbf345db1657ebc6fa4.svg";
export { ForwardRef as ReactComponent };